import { hasSeenIntroVideo } from './introVideo';

// Hikâye görevlerinin videoları: izlenenleri hatırlar ve dosyası henüz
// eklenmemiş videoların düğmesini gizlemek için dosyanın varlığını yoklar.

const WATCHED_PREFIX = 'storyVideoWatched:';
const INTRO_SRC = 'video/giris.mp4';

const availability = new Map(); // src -> true | false | Promise

export function storyVideoUrl(src) {
  if (!src) return '';
  if (/^https?:\/\//.test(src)) return src;
  return `${process.env.PUBLIC_URL || ''}/${src.replace(/^\/+/, '')}`;
}

function watchedKey(username) {
  return `${WATCHED_PREFIX}${username}`;
}

function readWatched(username) {
  try {
    return JSON.parse(localStorage.getItem(watchedKey(username)) || '[]');
  } catch {
    return [];
  }
}

export function hasWatchedStoryVideo(username, src) {
  if (!username || !src) return false;
  if (src === INTRO_SRC && hasSeenIntroVideo(username)) return true;
  return readWatched(username).includes(src);
}

export function markStoryVideoWatched(username, src) {
  if (!username || !src) return;
  try {
    const list = readWatched(username);
    if (!list.includes(src)) {
      list.push(src);
      localStorage.setItem(watchedKey(username), JSON.stringify(list));
    }
  } catch {
    /* tarayıcı saklamaya izin vermiyorsa video yine oynar */
  }
}

/** Video dosyası sunucuda var mı? (Eksik dosyada sunucu index.html döndürür.) */
export function probeStoryVideo(src) {
  if (!src) return Promise.resolve(false);
  const known = availability.get(src);
  if (known === true || known === false) return Promise.resolve(known);
  if (known) return known;
  const p = fetch(storyVideoUrl(src), { method: 'HEAD' })
    .then((r) => r.ok && (r.headers.get('content-type') || '').startsWith('video/'))
    .catch(() => false)
    .then((ok) => {
      availability.set(src, ok);
      return ok;
    });
  availability.set(src, p);
  return p;
}

export function markStoryVideoMissing(src) {
  if (src) availability.set(src, false);
}
